import React from 'react';
import { Link } from 'react-router-dom';

const LegalConsultation = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <div className="mb-6">
              <div className="w-20 h-1.5 bg-red-500 rounded-full mb-4"></div>
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                MetroBrix Legal: Free Real Estate Legal Consultation
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed">
                Get Expert Advice on RERA, Builder Refunds, Area Mismatch, 
                Stuck Projects & More — at No Cost!
              </p>
            </div>
            <div className="flex items-center space-x-4">
              <Link 
                to="/contact"
                className="bg-red-500 hover:bg-red-600 text-white px-8 py-3.5 rounded-full font-bold text-lg transition shadow-md inline-block"
              >
                Consult Now
              </Link>
              <span className="text-green-600 font-semibold text-sm bg-green-50 px-4 py-2 rounded-full">
                100% Free
              </span>
            </div>
          </div>
          <div className="hidden lg:flex justify-center">
            <img
              src="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400&q=80"
              alt="Legal Consultation"
              className="w-96 h-80 object-cover rounded-2xl shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LegalConsultation;
